<template>
  <div
    id="chatbox"
    ref="chatbox"
    v-resize="onResizeChatbox"
    :style="{ height: chatboxHeight, 'overflow-y': isMobile ? 'hidden' : 'auto' }"
    @scroll="onMessageScroll"
  >
    <!-- <div v-html="debug" style="position:absolute; color:red;z-index: 10;background: white"></div> -->
    <template v-if="selectedUser">
      <v-toolbar
        dark
        color="primary"
        flat
        :absolute="!isMobile"
        :fixed="isMobile"
        style="top: 0; background: #ff9d85;"
        :style="{ top: isMobile ? '56px' : '0px' }"
      >
        <v-btn
          flat
          dark
          fab
          small
          class="ma-0 btn-back extra-small"
          @click="$emit('onClose')"
          v-show="isMobile"
        >
          <v-icon medium>keyboard_arrow_left</v-icon>
        </v-btn>
        <v-toolbar-title class="white--text text-truncate"
          >{{ selectedUser.first_name }} {{ selectedUser.last_name }}</v-toolbar-title
        >

        <v-spacer></v-spacer>
        <v-btn
          flat
          dark
          fab
          small
          class="ma-0 btn-back"
          @click="$emit('onShowTool')"
          v-show="isMobile"
        >
          <v-icon medium>settings_applications</v-icon>
        </v-btn>
        <div v-show="!isMobile">
          <v-btn color="white" small outline @click="endSession" v-if="selectedUser.type == 'admin'"
            >End Session</v-btn
          >
          <v-btn
            color="white"
            small
            outline
            @click="openSession"
            v-else-if="selectedUser.type != 'admin'"
            >Open Session</v-btn
          >
        </div>
      </v-toolbar>
      <div
        id="chatbox-container"
        style=" position: relative; "
        :style="{
          'padding-bottom': chatinputHeight + 'px',
          'margin-top': isMobile ? '56px' : '0px',
          top: isMobile ? '0px' : '64px'
        }"
      >
        <template v-if="messages.length > 0">
          <div id="messages">
            <template v-if="isMobile">
              <div
                class="text-xs-center"
                style="background:#eee;padding-top:10px;padding-bottom:10px"
                @click="onLoadmore"
              >
                <template v-if="loadmore">
                  <v-progress-circular
                    indeterminate
                    color="grey"
                    small
                    class="mr-2"
                    :width="2"
                  ></v-progress-circular
                  >Loading
                </template>
                <template v-else @click="onLoadmore"
                  >Click to load more conversation</template
                >
              </div>
            </template>
            <template v-else>
              <div
                v-if="loadmore"
                class="text-xs-center"
                style="background:#eee;padding-top:10px;padding-bottom:10px"
              >
                <v-progress-circular
                  indeterminate
                  color="grey"
                  small
                  class="mr-2"
                  :width="2"
                ></v-progress-circular
                >Loading
              </div>
            </template>
            <template v-for="(message, index) in messages">
              <message-item
                v-if="messages"
                :key="'message-' + message.id + message.userid + message.pageid"
                v-model="messages[index]"
                :receiver="selectedUser"
              ></message-item>
            </template>
          </div>
        </template>
        <template v-else>
          <v-layout column justify-center fill-height>
            <div class="text-xs-center mt-5" style="color:#eee">
              <img src="/static/img/assets/livechat/no_message.png" alt />
              <p>No message</p>
            </div>
          </v-layout>
        </template>
      </div>

      <chat-input
        id="chatinput"
        :app="selectedUser.app"
        v-model="selectedUser"
        @onSendMessage="onSendMessage($event)"
      >
        <div v-if="!isAutoRefresh" class="text-xs-center" slot="header">
          <v-btn small round color="primary" @click="gotobottom" depressed>
            <v-icon class>arrow_drop_down</v-icon>Go to bottom
          </v-btn>
        </div>
      </chat-input>
    </template>
    <template v-else>
      <v-layout column justify-center fill-height>
        <div class="text-xs-center" style="color:#eee">
          <img src="/static/img/assets/livechat/no_user.png" alt />
          <p>Select a user</p>
        </div>
      </v-layout>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import messageItem from './livechat-message'
import chatInput from './livechat-chatinput'
import api from '@/api'
import moment from 'moment'

export default {
  props: ['value', 'isMobile'],
  data: function() {
    return {
      loadmore: false,

      chatboxHeight: 0,
      loading: false,
      maxTime: 10000,
      timer: '',
      isAutoRefresh: true,
      currentIndex: null,

      offset: 0,
      limit: 100,
      messages: [],

      // oldMessages: [],
      endChatlog: false,

      windowHeight: 0,

      newMessage: null,
      chatinputHeight: 0,
      debug: ''
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      selectedUser: 'getCurrentUser'
    })
  },
  components: {
    'message-item': messageItem,
    'chat-input': chatInput
  },
  created: function() {
    let vm = this
    this.resetChatlog()
    this.getLastedMessages()
    if (vm.isMobile) {
      document.body.onscroll = function() {
        vm.onMessageScroll()
      }
    }
    this.timer = setInterval(this.getLastedMessages, this.maxTime)
  },
  mounted: function() {
    let vm = this
  },
  methods: {
    onResizeChatbox: function() {
      var vm = this
      vm.$nextTick(function() {
        if (this.isMobile) {
          vm.chatboxHeight = 'auto'
          // vm.chatinputHeight = 0
        } else {
          vm.chatboxHeight =
            window.innerHeight - document.getElementById('main_toolbar').clientHeight + 'px'
        }
        if (document.getElementById('chatinput')) {
          vm.chatinputHeight = document.getElementById('chatinput').clientHeight
        }
        vm.debug =
          `Chatbox Height: ${vm.chatboxHeight}<br>` +
          `Input Height: ${vm.chatinputHeight}<br>` +
          `Screen Height: ${screen.height}<br>` +
          `Main Toolbar: ${document.getElementById('main_toolbar').clientHeight}<br>` +
          `Window: ${window.innerHeight}<br>`
      })
    },
    onSendMessage: function(payload) {
      this.messages.push(payload)
      this.snapBottom()
      // console.log(payload)
    },
    getLastedMessages: function() {
      var vm = this
      let limit = 15
      if (vm.messages.length == 0) {
        limit = 100
      }
      if (!vm.selectedUser) {
        return false
      }
      vm.getUserMessages(0, limit, true).then(
        function() {
          vm.onResizeChatbox()
          if (vm.isAutoRefresh && document.getElementById('messages')) {
            // $('#chatbox').animate({ scrollTop: document.getElementById('messages').clientHeight })
            vm.snapBottom()
          }
        },
        function(error) {
          // console.log(error)
        }
      )
    },
    getUserMessages: function(offset, limit, latest) {
      let vm = this
      return new Promise((resolve, reject) => {
        if (vm.selectedBot == null || vm.selectedUser == null || vm.loading || !vm.isAutoRefresh) {
          reject()
          // return false
        }
        vm.loading = true
        let data = {
          pageid: vm.selectedBot.pageid,
          userid: vm.selectedUser.userid,
          offset: offset,
          limit: limit,
          adminid: vm.$store.state.userid
        }
        if (!latest) {
          vm.loadmore = true
        }

        let auth = null
        api.getUserMessages(data, function(error, response) {
          if (error) {
            if (!latest) {
              vm.loadmore = false
            }

            reject(error)
          }
          if (response.data) {
            if (!latest && response.data.length == 0) {
              vm.endChatlog = true
            }
            if (latest) {
              if (vm.messages.length == 0) {
                var messages = response.data.reverse()
                vm.messages = []
                messages.map(function(el) {
                  vm.messages.push(el)
                })
                vm.$nextTick(function() {
                  if (vm.isAutoRefresh) {
                    vm.snapBottom()
                  }
                })
              } else {
                if (response.data[0].id == vm.currentIndex.id) {
                  // console.log('Noting Change')
                  vm.loading = false
                  resolve()
                } else {
                  let isFoundLatestIndex = false
                  let tmpIndex = null
                  vm.messages = vm.messages.splice(0, vm.currentIndex.index)
                  $.each(response.data, function(index, val) {
                    if (val.id == vm.currentIndex.id) {
                      // console.log('Found')
                      tmpIndex = index
                      isFoundLatestIndex = true

                      resolve()
                    }
                  })

                  if (isFoundLatestIndex) {
                    for (var i = tmpIndex; i >= 0; i--) {
                      vm.messages.push(response.data[i])
                    }

                    if (response.data[0]) {
                      vm.newMessage = response.data[0]
                    }

                    vm.snapBottom()
                  }
                }
              }
            } else {
              vm.messages = response.data.reverse()
              vm.loadmore = false
            }
            if (vm.messages.length > 0) {
              vm.currentIndex = {
                id: vm.messages[vm.messages.length - 1].id,
                index: vm.messages.length - 1
              }
            }
            vm.loading = false
          }
          resolve()
        })
      })
    },
    enableAutoUpdate: function() {
      this.isAutoRefresh = !this.isAutoRefresh
      if (this.isAutoRefresh) {
        this.timer = setInterval(this.getSummary, this.maxTime)
      } else {
        clearInterval(this.timer)
      }
    },
    onMessageScroll: function() {
      let scrollPosition = 0
      if (this.isMobile) {
        scrollPosition = window.pageYOffset + window.innerHeight
        let totalHeight = document.body.scrollHeight
        // console.log(totalHeight == scrollPosition)
        if (totalHeight == scrollPosition) {
          this.isAutoRefresh = true
        } else {
          this.isAutoRefresh = false
        }
        // console.log(scrollPosition, totalHeight)
        return false
      } else {
        let messages = $('#chatbox')
        scrollPosition = messages.scrollTop()
        let chatboxHeight = messages.outerHeight(true)
        let totalHeight = messages.prop('scrollHeight')
        // console.log(scrollPosition, chatboxHeight, totalHeight)
        if (totalHeight == scrollPosition + chatboxHeight) {
          this.isAutoRefresh = true
        } else {
          this.isAutoRefresh = false
        }
      }

      if (scrollPosition == 0) {
        this.onLoadmore().then(function() {})
      }
    },
    onLoadmore: function() {
      var vm = this
      return new Promise((resolve, reject) => {
        if (vm.loadmore) {
          reject()
        }
        vm.limit += 100
        vm.getUserMessages(vm.offset, vm.limit, false).then(
          function() {
            // $('#chatbox').animate({ scrollTop: 0 })
            resolve()
          },
          function() {}
        )
      })
    },
    snapBottom: function() {
      let vm = this
      if (!vm.isAutoRefresh || vm.loadmore) {
        return false
      }
      vm.gotobottom()
    },
    gotobottom: function() {
      this.$nextTick(() => {
        let messages = $('#messages')
        if (messages.length > 0) {
          if (this.isMobile) {
            window.scrollTo(
              0,
              document.body.scrollHeight +
                (this.chatinputHeight == 0 ? 114 : this.chatinputHeight * 2)
            )
          } else {
            document
              .getElementById('chatbox')
              .scrollTo(0, document.getElementById('messages').clientHeight)
          }
        }
      })
    },
    resetChatlog: function() {
      this.messages = []
      this.offset = 0
      this.limit = 100
      this.endChatlog = false
      this.loading = false
      this.loadmore = false
      this.isAutoRefresh = true
      this.newMessage = null
    },
    endSession: function() {
      let vm = this
      if (vm.selectedUser == null || vm.selectedBot == null) {
        return false
      }
      let data = {
        pageid: vm.selectedBot.pageid,
        userid: vm.selectedUser.userid
      }
      vm.$store.dispatch('loading')
      api.endSessionChat(data, function(error, response) {
        if (error) {
          console.error(error)
          vm.$store.dispatch('loading')
          return
        }
        vm.$emit('endSession')
        vm.selectedUser = null

        vm.$store.dispatch('loading')
      })
    },
    openSession: function() {
      let vm = this
      if (vm.selectedUser == null || vm.selectedBot == null) {
        return false
      }
      let data = {
        pageid: vm.selectedBot.pageid,
        userid: vm.selectedUser.userid
      }
      vm.$store.dispatch('loading')
      api.openSessionChat(data, function(error, response) {
        if (error) {
          console.error(error)
          vm.$store.dispatch('loading')
          return
        }
        vm.$emit('openSession')

        vm.$store.dispatch('loading')
      })
    }
  },
  watch: {
    value: function(newVal, oldVal) {
      this.selectedUser = newVal
      if (newVal == null || oldVal == null || oldVal != newVal) {
        this.resetChatlog()
        this.getLastedMessages()
      }
    },
    selectedBot: function(newVal, oldVal) {
      if (newVal != oldVal) {
        this.selectedUser = null
        this.resetChatlog()
      }
    }
  },
  beforeDestroy: function() {
    clearInterval(this.timer)
    document.removeEventListener('scroll', null, false)
  }
}
</script>

<style lang="scss" scoped>
.btn-back i {
  line-height: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/view/livechat/livechat-chatbox.vue